import { StringMap } from "i18next";
import { CategoryMap, CategoryMenu } from "../../components/category-navbar";
import { ToTranslateField } from "../../types/translate-field";

export interface GetNavbarCategoriesReponse {
  items: NavbarItem[]
}

export interface NavbarItem {
  category_id: string;
  category_eng: string;
  category_cnt: string;
  category_cns: string;

  dept_display_name: string;
  dept_id: string;
  dept_name_eng: string;
  dept_name_cnt: string;
  dept_name_cns: string;

  sub_cat_id: string;
  sub_cat_name_eng: string;
  sub_cat_name_cnt: string;
  sub_cat_name_cns: string;

  category_display_order: String;
  sub_cat_display_order: String;  
  dept_display_order: String;
}

interface NavItemData {
  id: string
  name_eng: string
  name_cnt: string
  name_cns: string
  display_order: Number
  extra?: string
}

class NavData {
  category_id: string;
  category_eng: string;
  category_cnt: string;
  category_cns: string;

  dept_display_name: string;
  dept_id: string;
  dept_name_eng: string;
  dept_name_cnt: string;
  dept_name_cns: string;

  sub_cat_id: string;
  sub_cat_name_eng: string;
  sub_cat_name_cnt: string;
  sub_cat_name_cns: string;

  category_display_order: String;
  sub_cat_display_order: String;
  dept_display_order: String;

  constructor(data: NavbarItem) {
    this.category_id = data.category_id
    this.category_eng = data.category_eng
    this.category_cnt = data.category_cnt
    this.category_cns = data.category_cns

    this.dept_display_name = data.dept_display_name
    this.dept_id = data.dept_id
    this.dept_name_eng = data.dept_name_eng
    this.dept_name_cnt = data.dept_name_cnt
    this.dept_name_cns = data.dept_name_cns

    this.sub_cat_id = data.sub_cat_id
    this.sub_cat_name_eng = data.sub_cat_name_eng
    this.sub_cat_name_cnt = data.sub_cat_name_cnt
    this.sub_cat_name_cns = data.sub_cat_name_cns

    this.category_display_order = data.category_display_order
    this.sub_cat_display_order = data.sub_cat_display_order    
    this.dept_display_order = data.dept_display_order
  }

  GetCategory(): NavItemData {
    return {
      id: this.category_id,
      name_eng: this.category_eng,
      name_cnt: this.category_cnt,
      name_cns: this.category_cns,
      display_order : parseInt(this.category_display_order?`${this.category_display_order}`:"")
    }
  }

  GetDepartment(): NavItemData {
    return {
      // dept_display_name: this.dept_display_name,
      id: this.dept_id,
      name_eng: this.dept_display_name,
      name_cnt: this.dept_name_cnt,
      name_cns: this.dept_name_cns,
      display_order : parseInt(this.dept_display_order?`${this.dept_display_order}`:""),
      extra: this.category_id
    }
  }

  GetSubCat(): NavItemData {
    return {
      id: this.sub_cat_id,
      name_eng: this.sub_cat_name_eng,
      name_cnt: this.sub_cat_name_cnt,
      name_cns: this.sub_cat_name_cns,
      display_order : parseInt(this.sub_cat_display_order?`${this.sub_cat_display_order}`:""),
      extra: this.dept_id
    }
  }
}



export const TransformToCategoryMenu = (res: NavbarItem[]): CategoryMap => {

  const items: NavData[] = res.map(x => { return new NavData(x) })

  const cats: CategoryMenu[] = items.map(x => x.GetCategory()).map(x => { return { label: ToTranslateField(x.id, x.name_eng, x.name_cnt, x.name_cns), slug: `/Category/${x.id}`, display_order: parseInt(x.display_order?`${x.display_order}`:"") } }).filter((v, i, s) => s.map(x => x.slug).indexOf(v.slug) === i).sort(function(x,y) {
    if (x.display_order > y.display_order) {
      return 1;
    }
    if (x.display_order < y.display_order) {
        return -1;
    }
    return 0;
  })
  const depts: CategoryMenu[] = items.map(x => x.GetDepartment()).map(x => { return { label: ToTranslateField(x.id, x.name_eng, x.name_cnt, x.name_cns), slug: `${x.extra!}/Department/${x.id}`, display_order: parseInt(x.id.substring(1)) } }).filter((v, i, s) => s.map(x => x.slug).indexOf(v.slug) === i).sort(function(x,y) {
    if (x.display_order > y.display_order) {
      return 1;
    }
    if (x.display_order < y.display_order) {
        return -1;
    }
    return 0;
  })
  const subcats: CategoryMenu[] = items.map(x => x.GetSubCat()).map(x => { return { label: ToTranslateField(x.id, x.name_eng, x.name_cnt, x.name_cns), slug: `${x.extra!}/${x.id}`, display_order: parseInt(x.display_order?`${x.display_order}`:"") } }).sort(function(x,y) {
    if (x.display_order > y.display_order) {
      return 1;
    }
    if (x.display_order < y.display_order) {
        return -1;
    }
    return 0;
  })



  const deptMapping: { info: CategoryMenu, subCat: CategoryMenu[] }[] =
    depts.map(x => {
      return {
        info: x,
        subCat: subcats.filter(y => y.slug.split('/')[0] == x.slug.split('/Department/')[1])
          .map(y => {
            return {
              label: y.label,
              slug: `/SubCat/${y.slug.split('/')[1]}`,
              display_order: y.display_order,
            }
          }).sort(function(x,y) {
            if (x.display_order > y.display_order) {
              return 1;
            }
            if (x.display_order < y.display_order) {
                return -1;
            }
            return 0;
          }),
          display_order: x.display_order,
      }
    }).sort(function(x,y) {
      if (x.display_order > y.display_order) {
        return 1;
      }
      if (x.display_order < y.display_order) {
          return -1;
      }
      return 0;
    })
  return {
    categories: cats,
    departments: deptMapping
  }
}